export const routes = {
  addProcess: '/add-process',
  archive: '/archive',
  forgetPassword: '/forget-password',
  home: '/',
  invite: '/invite',
  resetPassword: '/reset-password',
  signIn: '/signin',
  signUp: '/signup',
};
